<template>
<v-row>
    <v-col cols="1"></v-col>
    <v-col cols="10">
        <v-card-text>
            <h2 class="indigo--text text--darken-4"><u>Etat civil</u></h2>
            <br>
            <center>
                <v-img src="@/assets/cv/id-card4.png" style="font-family:'Courier New', Helvetica, Arial, sans-serif; font-size:1.5rem" width="860" class="font-weight-bold text-left">
                    <v-row class="mt-1">
                        <v-col cols="4"></v-col>
                        <v-col cols="3" class="label-identity">Nom</v-col>
                        <v-col cols="5">MSKINE</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4"></v-col>
                        <v-col cols="3" class="label-identity">Prénom</v-col>
                        <v-col cols="5">CYRIL</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4"></v-col>
                        <v-col cols="3" class="label-identity">Email</v-col>
                        <v-col cols="5">cmskine@hotmail.fr</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4"></v-col>
                        <v-col cols="3" class="label-identity">Téléphone</v-col>
                        <v-col cols="5">06 75 50 48 91</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4"></v-col>
                        <v-col cols="3" class="label-identity">Adresse</v-col>
                        <v-col cols="5">25 avenue de la forêt<br/>Apt B24<br/>33700 - Mérignac</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4"></v-col>
                        <v-col cols="3" class="label-identity">Né le</v-col>
                        <v-col cols="5">{{ birthDate.toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' }) }} ({{ myAge }} ans)</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" class="pl-10 grey--text text--darken-2"><small style="font-size:1rem">République française</small></v-col>
                        <v-col cols="3" class="label-identity">Situation<br/>familiale</v-col>
                        <v-col cols="5">Célibataire, 1 enfant</v-col>
                    </v-row>
                </v-img>
            </center>
        </v-card-text>
    </v-col>
    <v-col cols="1"></v-col>
</v-row>
</template>

<script>
export default {
    name: 'Identity',

    data: () => ({
        birthDate: new Date('1982-05-03'),
    }),
    computed: {
        myAge: function () {
            var diffMs = Date.now() - this.birthDate.getTime()
            var ageDt = new Date(diffMs)
            return Math.round(Math.abs(ageDt.getUTCFullYear() - 1970), 1)
        },
    },
}
</script>
<style scoped>
.label-identity {
  color: navy;
  font-size: smaller;
}
</style>
